module.exports = __webpack_public_path__ + "img/vremenco.36663c39.jpg";